module.exports = __webpack_public_path__ + "img/gp_promotion_male_1.535965fb.png";